import { firestore } from "firebase/app";

import { formatDateShort } from "./DateFormatter";

/**
 * The short-date renderings a Panel falls back to once a low or empty battery has cleared its clock.
 *
 * `01.01.01` (2001-01-01) and `02.03.87` (1987-03-02) are RTC factory defaults; `01.01.70` is the
 * epoch, i.e. a clock that was never set at all rather than one that reset to a default.
 *
 * Matching the rendered `dd.MM.yy` string rather than a date range is deliberate: a range would also
 * catch a legitimately old drying, whose end date must never be rebuilt from its samples.
 */
const PLACEHOLDER_CLOCK_DATES = ["01.01.01", "02.03.87", "01.01.70"];

/**
 * Whether a date is one of the placeholders a dead Panel battery produces, and therefore has to be
 * rebuilt from the run's samples before it is shown.
 *
 * A false negative leaves the raw placeholder on the customer's screen; a false positive rebuilds
 * the end date of a drying that was measured correctly. See `docs/devices/panel-clock-corrections.md`.
 */
export function hasPlaceholderClockDate(
  date: Date | firestore.Timestamp
): boolean {
  return PLACEHOLDER_CLOCK_DATES.includes(formatDateShort(date));
}
